/**
 * This is used to filter away errors that would otherwise be logged to Sentry and flood the logs.
 * It happens when people try to use the attributes to try to inject code or markup.
 */
export function isAttributeStuffing(key: string, namespace: string): boolean {
    if (namespace !== 'attributes') return false;
    return /[[\]#<*()]+/.test(key);
}
